export default __webpack_public_path__ + "static/media/ICON17.f7832217.svg";